import type { QuestionStatus } from "../../types";

const LABELS: Record<QuestionStatus, string> = {
  pending: "未確認",
  approved: "承認済み",
  displaying: "表示中",
  answered: "回答済み",
  hidden: "非表示",
  archived: "アーカイブ",
};

export function StatusBadge({ status }: { status: QuestionStatus }) {
  return <span className={`status-badge status-${status}`}>{LABELS[status]}</span>;
}

export function permissionLabel(p: string): string {
  switch (p) {
    case "allow_with_name":
      return "氏名・会社名つきで表示可";
    case "allow_anonymous":
      return "匿名なら表示可";
    case "do_not_display":
      return "表示不可";
    default:
      return p;
  }
}

export function nameTypeLabel(t: string): string {
  switch (t) {
    case "real_name":
      return "氏名・会社名";
    case "company_only":
      return "会社名のみ";
    case "anonymous":
      return "匿名";
    default:
      return t;
  }
}
